import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  managedList: [],
  account:null,
  managed: null,
  error: false,
  loading: false,
  loaded:false,
  realManaged:null
};
const resetmanagedState = (state, action) => {
  return updateObject(state, initialState)
}
const initManagedStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    loaded:false
  });
};

const setManaged = (state, action) => {
  return updateObject(state, {
    realManaged: action.realManaged,
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchManagedFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_MANAGED_START:
      return initManagedStart(state, action);
    case actionTypes.SET_MANAGED:
      return setManaged(state, action);
    case actionTypes.FETCH_MANAGED_FAILED:
      return fetchManagedFailed(state, action);
    default:
      return state;
  }
};

export default reducer;
